var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-amap',{staticClass:"amap-demo",attrs:{"vid":"amapDemo","center":_vm.location,"zoom":14}},[_c('el-amap-marker',{attrs:{"vid":"component-marker","position":_vm.componentMarker.position}}),_c('el-amap-info-window',{attrs:{"position":_vm.componentMarker.position,"offset":_vm.componentMarker.offset,"content":_vm.componentMarker.content}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }